import materialType from './material-type';

export default materialType.filter(mt =>
  [
    // Кирпичный
    'brick',
    // Монолитный
    'monolith',
    // Деревянный
    'wood',
    // Щитовой
    'boards',
    // Каркасный
    'wireframe',
    // Газобетонный блок
    'aerocreteBlock',
    // Газосиликатный блок
    'gasSilicateBlock',
    // Пенобетонный блок
    'foamConcreteBlock',
  ].includes(mt.key),
);
